export const getUnusedElementIndex = (element, elementalsTokens) => {
  return elementalsTokens.findIndex(token => token.tokenName === element && token.isUsed === false);
}
